import { ROLES } from 'constants/roles';

export const canNavigate = (userRole: ROLES, allowedRoles?: ROLES[]) => {
  if (allowedRoles?.includes(userRole)) return true;
  return false;
};
